module.exports = __webpack_public_path__ + "img/2.12ace1b0.png";